import React from 'react';
import { Col } from 'reactstrap';
import App_data from '../../../config/App_data';
import SelectionPopover from 'react-selection-popover';
import language from '../../../../assets/languages/language';
import { renderHTMLContent } from '../../../../common/function';

const ViewNormalQuestions = ({
  selectedCaseQuestionData,
  strikeThroughArr,
  userChoice,
  getHighlightedText,
  content,
  optionsArr = [],
  showPopover,
  clickOption,
  deselectPopover,
  selectPopover,
  addHighlightToText,
  deleteHighlightFromText,
}) => {
  return (
    <Col xs='12' sm='12' lg='12'>
      {selectedCaseQuestionData && selectedCaseQuestionData.question ? (
        <div className='qus-wrapper ques-bold-remove d-block all-ques'>
          <div
            style={{
              position: 'relative',
              marginTop: '8px',
              maxWidth: '100%',
            }}
          >
            <div data-selectable>
              {renderHTMLContent(
                content,
                "div",
                "qus-title d-inline-block w-100"
              )}
            </div>
            <SelectionPopover
              showPopover={showPopover}
              onSelect={() => selectPopover()}
              onDeselect={() => deselectPopover()}
            >
              {getHighlightedText === -1 ? (
                <div className='highlight-popover tooltip_wrap'>
                  <img
                    src={App_data.frontend_url + '/img/high-edit-ico.svg'}
                    alt='523'
                    width='30'
                    onClick={addHighlightToText}
                  />
                  <div className='tootip_box'>{language.LC().Click_me_to_highlight}</div>
                </div>
              ) : (
                <div className='highlight-popover tooltip_wrap'>
                  <img
                    src={App_data.frontend_url + '/img/icon_select_text.png'}
                    alt='523'
                    width='30'
                    onClick={deleteHighlightFromText}
                  />
                  <div className='tootip_box'>{language.LC().Click_me_to_unhighlight}</div>
                </div>
              )}
            </SelectionPopover>
          </div>
        </div>
      ) : null}
      <div className='row'>
        {optionsArr.map((item, index) => {
          return (
            <div
              className='col-sm-12'
              id={item}
              key={index}
              onClick={(e) => {
                clickOption(
                  item,
                  selectedCaseQuestionData && selectedCaseQuestionData.id
                    ? selectedCaseQuestionData.id
                    : null,
                  selectedCaseQuestionData,
                  e,
                );
              }}
              onContextMenu={(e) => {
                clickOption(
                  item,
                  selectedCaseQuestionData && selectedCaseQuestionData.id
                    ? selectedCaseQuestionData.id
                    : null,
                  selectedCaseQuestionData,
                  e,
                );
              }}
              onTouchStart={(e) => {
                this.onTouchStart(e, item);
              }}
              onTouchCancel={(e) => {
                this.onTouchCancel(e);
              }}
              onTouchEnd={(e) => {
                this.onTouchEnd(e);
              }}
              onTouchMove={(e) => {
                this.onTouchMove(e);
              }}
            >
              <div
                className={`answer_box ${userChoice[selectedCaseQuestionData.id] === item
                  ? `border-yellow`
                  : 'border-black'
                  }`}
              >
                <div
                  className={`answer_count highlight_choice no-selection ${item === 'choice_a'
                    ? strikeThroughArr.includes('choice_a')
                      ? 'strikethrough'
                      : ''
                    : item === 'choice_b'
                      ? strikeThroughArr.includes('choice_b')
                        ? 'strikethrough'
                        : ''
                      : item === 'choice_c'
                        ? strikeThroughArr.includes('choice_c')
                          ? 'strikethrough'
                          : ''
                        : ''
                    }`}
                >
                  {item === 'choice_a'
                    ? language.LC().A
                    : item === 'choice_b'
                      ? language.LC().B
                      : language.LC().C}
                </div>
                <p
                  className={`ans_box_text tooltip_wrap ${item === 'choice_a'
                    ? strikeThroughArr.includes('choice_a')
                      ? 'strikethrough'
                      : ''
                    : item === 'choice_b'
                      ? strikeThroughArr.includes('choice_b')
                        ? 'strikethrough'
                        : ''
                      : item === 'choice_c'
                        ? strikeThroughArr.includes('choice_c')
                          ? 'strikethrough'
                          : ''
                        : ''
                    }`}
                >
                  {selectedCaseQuestionData && selectedCaseQuestionData[item] ? (
                   renderHTMLContent(
                    selectedCaseQuestionData[item],
                    "span",
                    "no-selection",
                    { contentEditable: false }
                  )                  
                  ) : null}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </Col>
  );
};

export default ViewNormalQuestions;



// WEBPACK FOOTER //
// ./src/views/CBT/CFA3CBT/Questions/ViewNormalQuestions.jsx